import React from 'react';
import { connect } from 'react-redux';
import { Button} from 'reactstrap';
import ApuaWhiteTextLogo from '../../ImageAssets/ApuaWhiteTextLogo.png';
import { setLoginPage } from '../../General/Actions';

class SignUpComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            serialNumber: "",
            macAddress: "",
            allDevicesArray:{}
        }
    }

    componentDidMount() {
    }

    registerButtonClicked = () => {
        window.location.reload();
    }

    registerPartComponent() {
        return (
            <div className=" col-md-12 row m-0 d-flex flex-column" style={{ height: '100%' }}>
                <div className="col-md-12 row pt-5 m-0" style={{flex:1}}>
                    <div className="col-md-1"></div>
                    <div className="col-md-6 pl-5 ml-3"><img alt="" src={ApuaWhiteTextLogo} /></div>
                    <div className="col-md-5"></div>
                </div>
                <div className="col-md-12 row p-0 m-0 " style={{  flex:4, alignItems: 'center' }}>
                    <div className="col-md-1"></div>
                    <div className="loginPageLeftPart col-md-9" >
                        <div className="col-md-12  pl-5" style={{ marginTop: '-52px' }}>
                            <div className="mb-4 col-md-12" style={{ fontSize: 40, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.LoginPageYoutAccountDiv}</div>
                            <div className="mb-1 col-md-12" style={{ fontSize: 16, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.LoginPagePayDiv}</div>
                            <div className="mb-1 col-md-12" style={{ fontSize: 16, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.LoginPageManageDiv}</div>
                            <div className="mb-2 col-md-12" style={{ fontSize: 16, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.LoginPageGetNotificationDiv}</div>
                            <div className="col-md-12 " style={{ marginTop: 50 }}>
                                <Button className="loginPageRegisterButton" style={{ color: '#ffffff',fontSize: 18 }} onClick={() => { this.registerButtonClicked() }}>
                                    {this.props.locales.LoginPageDoNtHavAnAccountBtn} <span style={{ fontSize: 18 , fontWeight: 'bold', color: '#ffffff' }}> {this.props.locales.LoginPageSignUpBtnSpan}</span>
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

    render() {
        return( this.registerPartComponent() )
    }

}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        }
    }
}

const SignUpComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SignUpComponent)


export default SignUpComponentContainer;

